export const required = value => (value || typeof value === 'number' ? undefined : 'Required');

export const hasCorrectAnswer = value => (value !== 'answers[-1]' ? undefined : 'Please select a correct answer');

export const atLeastOneItem = array => (array.length > 0 ? undefined : 'Please enter at least one');

export const listItemsHaveValue = array => (array.every(item => item.value) ? undefined : 'Please enter a value for answers');
